/**
 * <InfoField />
 *
 * @parent anybody
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './InfoField.scss';

class InfoField extends React.Component {
  static propTypes = {
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
      PropTypes.object,
    ]).isRequired,

    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
      PropTypes.object,
    ]).isRequired,

  }

  constructor(props) {
    super(props);
  }

  render() {

    let labelContent, valueContent;

    const {
      label,
      value,
      className,
    } = this.props;

    if (typeof value == 'function') {
      valueContent = label(label);
    } else {
      valueContent = value;
    }

    if (typeof label == 'function') {
      labelContent = label(value);
    } else {
      labelContent = label;
    }

    return (
      <div className={classnames('info-field', className)} style={{height: '70px'}}>
        <label>{labelContent}</label>
        <div className='info-value'>
          {valueContent}
        </div>
      </div>
    )
  }
}

export default InfoField;



// WEBPACK FOOTER //
// ./src/components/UI/InfoField/index.js